import axios from 'axios';
import jquery from 'jquery';
import validation from 'jquery-validation';
import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";

// Sentry.init({
//     dsn: 'https://5ddf5ec2a798440a99105dea6de06597@o357564.ingest.sentry.io/5614792',
//     integrations: [
//         new Integrations.BrowserTracing(),
//     ],
//     tracesSampleRate: 1.0,
// });

try {
    window.$ = window.jQuery = require('jquery');

    //require('bootstrap');
} catch (e) {}
